var map = {
	"./": [
		"8hXn",
		1
	],
	"./about": [
		"FBzZ",
		4
	],
	"./about.vue": [
		"FBzZ",
		4
	],
	"./academic": [
		"0byE",
		3
	],
	"./academic.vue": [
		"0byE",
		3
	],
	"./collection": [
		"XjNB",
		2
	],
	"./collection.vue": [
		"XjNB",
		2
	],
	"./detail": [
		"GwIj",
		7
	],
	"./detail.vue": [
		"GwIj",
		7
	],
	"./exhibition": [
		"vJ0Q",
		6,
		0
	],
	"./exhibition.vue": [
		"vJ0Q",
		6,
		0
	],
	"./index": [
		"8hXn",
		1
	],
	"./index.vue": [
		"8hXn",
		1
	],
	"./news": [
		"uxuc",
		5,
		0
	],
	"./news.vue": [
		"uxuc",
		5,
		0
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "MWF8";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/views lazy ^\.\/.*$
// module id = MWF8
// module chunks = 10